module.exports = __webpack_public_path__ + "static/home-slideshow-03@2x-220eb4c5079f32f517e9e436e3de8a14.jpg";